<template>
  <div v-if="inPreview">
    <div v-if="generatingPreview" class="relative">
      <b-skeleton
        animation="fade"
        width="100%"
        height="60vh"
      />
      <div class="absolute top-0 left-0 w-100 h-100 d-flex justify-center items-center gap-4">
        <b-spinner />
        <span>Generando previsualización</span>
      </div>
    </div>
    <b-overlay
      :show="saving"
    >
      <iframe
        v-if="!generatingPreview && pdfUrl !== '' && pdfUrl != null"
        class="w-100"
        :src="pdfUrl"
        style="height: 70vh;"
        name="pdfPreviewIframe"
        title="pdfPreviewIframe"
      />
      <template #overlay>
        <div class="d-flex justify-content-center align-items-center">
          <b-spinner
            class="mr-2"
          />
          <small>Creando documento...</small>
        </div>
      </template>
    </b-overlay>
    <div class="row justify-end">
      <vs-button
        class="mt-5 mr-5"
        data-cy="cancel"
        @click="backToForm"
        color="primary"
        :disabled="generatingPreview || saving"
      >
        Volver
      </vs-button>
      <vs-button
        class="mt-5 mr-5"
        data-cy="save"
        @click="save"
        color="success"
        :disabled="generatingPreview || saving"
      >
        Crear
      </vs-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PdfPreviewComplete',
  props: {
    inPreview: Boolean,
    generatingPreview: Boolean,
    saving: Boolean,
    pdfUrl: String,
    backToForm: Function,
    save: Function
  }
};
</script>
